import { ImageWrapper } from '../../../common/wrappers/ImageWrapper';
import image from '../../../../assets/images/games/zdar-escape-game/ciphers/16/cipher-transparent.webp';

export default function ZdarConesCipher() {
    return (
        <div className="zdar-cones-cipher">
            <div className="zdar-cipher-text">Hledáš písmeno, které zároveň ...</div>
            <div className="zdar-cipher-text zdar-cones-cipher-heading">Písmeno 1</div>
            <div className="zdar-cipher-text">
                <ol>
                    <li>je v kruhu</li>
                    <li>není ve čtverci</li>
                    <li>není v obdélníku</li>
                    <li>je v srdci</li>
                    <li>není ve hvězdě</li>
                    <li>je v trojúhelníku</li>
                </ol>
            </div>
            <div className="zdar-cipher-text zdar-cones-cipher-heading">Písmeno 2</div>
            <div className="zdar-cipher-text">
                <ol>
                    <li>není v srdci</li>
                    <li>je ve čtverci</li>
                    <li>není v kruhu</li>
                    <li>není v trojúhelníku</li>
                    <li>je v obdélníku</li>
                    <li>není ve hvězdě</li>
                </ol>
            </div>
            <div className="zdar-cipher-text zdar-cones-cipher-heading">Písmeno 3</div>
            <div className="zdar-cipher-text">
                <ol>
                    <li>není ve čtverci</li>
                    <li>je v trojúhelníku</li>
                    <li>není ve hvězdě</li>
                    <li>není v kruhu</li>
                    <li>je v srdci</li>
                    <li>není v obdélníku</li>
                </ol>
            </div>
            <div className="zdar-cipher-text zdar-cones-cipher-heading">Písmeno 4</div>
            <div className="zdar-cipher-text">
                <ol>
                    <li>je v kruhu</li>
                    <li>není ve hvězdě</li>
                    <li>je v obdélníku</li>
                    <li>není v trojúhelníku</li>
                    <li>není ve čtverci</li>
                </ol>
            </div>
            <div className="zdar-cipher-text zdar-cones-cipher-heading">Písmeno 5</div>
            <div className="zdar-cipher-text">
                <ol>
                    <li>není ve čtverci</li>
                    <li>je ve hvězdě</li>
                    <li>je v trojúhelníku</li>
                    <li>není v kruhu</li>
                </ol>
            </div>
            <div className="zdar-cipher-text zdar-cones-cipher-heading">Písmeno 6</div>
            <div className="zdar-cipher-text">
                <ol>
                    <li>není ve čtverci</li>
                    <li>je v obdélníku</li>
                    <li>není v kruhu</li>
                    <li>je v trojúhelníku</li>
                    <li>je v srdci</li>
                </ol>
            </div>
            <div className="cipher-image">
                <ImageWrapper src={image} alt="cipher" shouldScroll={true} allowLightbox={false} />
            </div>
            <div className="zdar-cipher-text zdar-cones-cipher-additional">
                Kód získáte uspořádáním písmen do smysluplného českého slova.
            </div>
        </div>
    );
}
